import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PartyApiService } from './services/party-api';
import { CanadaPostInputComponent } from './components/canada-post-input/canada-post-input.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ValidateDirective } from './directives/validate';
import { DisableAutocompleteDirective } from './directives/disable-autocomplete.directive';
import { SpinnerToSuccessSvgComponent } from './components/spinner-to-success-svg/spinner-to-success-svg.component';
import { GiantRadioButtonComponent } from './components/giant-radio-button/giant-radio-button.component';
import { SelectComponent } from './components/select/select.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalComponent } from './components/modal/modal.component';
import { LoadingCardComponent } from './components/loading-card/loading-card.component';
import { FormWasSubmittedDirective } from './directives/form-was-submitted.directive';
import { BackButtonRedirectDirective } from './directives/back-button-redirect.directive';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
// eslint-disable-next-line max-len
import { ContactCustomerSidebarComponent } from './components/contact-customer-sidebar/contact-customer-sidebar.component';
import { GlobalConfigService } from './utils/global-config.service';

// AoT requires an exported function for Lottie animations
export function playerFactory() {
	return player;
}
  
@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule,
		NgbTooltipModule,
		NgSelectModule,
		LottieModule.forRoot({ player: playerFactory })
	],
	exports: [
		TranslateModule,
		CanadaPostInputComponent,
		GiantRadioButtonComponent,
		ValidateDirective,
		DisableAutocompleteDirective,
		SpinnerToSuccessSvgComponent,
		TooltipComponent,
		SelectComponent,
		ModalComponent,
		FormWasSubmittedDirective,
		BackButtonRedirectDirective,
		LoadingCardComponent,
		ContactCustomerSidebarComponent
	],
	declarations: [
		CanadaPostInputComponent,
		GiantRadioButtonComponent,
		ValidateDirective,
		DisableAutocompleteDirective,
		SpinnerToSuccessSvgComponent,
		TooltipComponent,
		SelectComponent,
		ModalComponent,
		FormWasSubmittedDirective,
		BackButtonRedirectDirective,
		LoadingCardComponent,
		ContactCustomerSidebarComponent
	],
	providers: [
		PartyApiService,
		GlobalConfigService
	]
})
export class SharedModule {}
